import React, { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import arrow from "../../assets/icons/arrow_down.svg";
import nft_placeholder from "../../assets/placeholder/placeholder_large.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import { MOBILE } from "../../constants/breakpoints";

const ImageSection = (props: any) => {
  const [nftData, setNftData] = useState<any>({});

  const wallet = useSelector((state: RootState) => state.walletState);
  const navigate = useNavigate();

  useEffect(() => {
    if (props?.nftMetadata) {
      setNftData(JSON.parse(props?.nftMetadata.metadata));
    }
  }, [props?.nftMetadata]);

  const handleBackClick = () => {
    navigate(`/assets/${wallet.assetChain}/${wallet.assetAddress}`);
  };

  return (
    <>
      {nftData && nftData.image ? (
        <div>
          <div
            css={css`
              @media (max-width: ${MOBILE}px) {
                display: flex;
                justify-content: space-between;
              }
            `}
          >
            <img
              css={css`
                width: 580px;
                object-fit: cover;
                border: 1px solid #ccc4b3;
                border-radius: 24px;
                margin-top: 40px;

                @media (max-width: ${MOBILE}px) {
                  width: 106px;
                  height: 135.497px;
                }
              `}
              src={nftData?.image?.includes('ipfs://') ? `https://cf-ipfs.com/ipfs/${nftData?.image?.split('://')[1]}` : nftData?.image}
              alt=""
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default ImageSection;
